
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import { showToast, toast_error_type } from "@/utils/ShowCompUtils";
import { PropType, computed, defineComponent, onUnmounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import ErrorMsgInfo from "../model/ErrorMsgInfo";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "ErrorMsg",
  props: {
    vin: {
      type: String as PropType<string>,
      required: true,
      defualt: "",
    },
  },
  setup(props, context) {
    const router = useRouter();
    const route = useRoute();
    const carVin = computed<string>(() => props.vin);
    const errorMsgInfo = ref<Array<ErrorMsgInfo>>();
    const { t } = useI18n();

    let errorMsgInterval: any | undefined;
    const getErrorMessageF = () => {
      Api.getErrorMessage(carVin.value)
        .then((val) => {
          if (val) {
            if (val?.err_no == ResultCodeType.success_200) {
              errorMsgInfo.value = val.result;
            }
          }
        })
        .catch(() => {
          showToast(t("datarequestfailed"), toast_error_type);
        });
    };
    const IsaVailable = () => {
      errorMsgInterval && clearInterval(errorMsgInterval);
      errorMsgInterval = setInterval(() => {
        getErrorMessageF();
      }, 1000);
    };
    IsaVailable();
    onUnmounted(() => {
      clearInterval(errorMsgInterval);
    });

    return { errorMsgInfo };
  },
});
